<template>
  <div ref="lastArticlesHeader"
       id="lastArticlesContainer"
  >
    <v-toolbar class="lastArticlesHeader" elevation="0"
    >
      <v-row>
        <v-col class="d-flex justify-start ml-2">
          <v-toolbar-title class="textSize__16">
            Zuletzt angesehen
          </v-toolbar-title>
        </v-col>
        <v-col cols="1" class="d-flex justify-end mr-2">
        </v-col>
      </v-row>
    </v-toolbar>
      <product-list :renderData="renderData" v-if="!isLoading"/>
      <div class="textSize__16 text-align-left" v-if="!isLoading && renderData.products.length === 0">
        Du hast Dir leider noch keine Artikel angesehen.
      </div>
      <v-container class="lastArticlesWrapper" v-if="isLoading">

        <v-row
            class="articleCardRow"
        >
          <v-col cols="12"
                 class="articleCardCol"
                 v-for="index in 4"
                 :key="index"
          >
            <v-card class="articleCard"
                    elevation="0"
                    v-bind:class="{cartItem: renderData.cart && !renderData.order}"
                    light
            >
              <v-list-item three-line class="skeletonWrapper__li">
                <v-skeleton-loader class="skeletonAvatar" type="avatar">

                </v-skeleton-loader>

                <v-list-item-content>
                  <v-container>
                    <v-row class="articleCard__details">
                      <v-col cols="12"
                             class="articleNameSmall"
                      >
                        <v-skeleton-loader type="text"/>
                      </v-col>
                      <v-col cols="12" class="articleStatus">
                        <v-skeleton-loader type="text"/>
                      </v-col>
                      <v-col cols="12" class="pa-0 articlePrice">
                        <v-skeleton-loader type="text"/>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    <div class="bottomFiller"/>
    </div>
</template>

<script>
import axios from "axios";
import {mapGetters, mapActions, mapMutations} from 'vuex';
import ProductList from "@/app/productListing/productList";

export default {
  name: "lastArticle",
  components: {ProductList},
  data:() => {
    return {
      isLoading: true,
      renderData: {cart: false, category: false, products: []},
      headerShown: true,

      isIntersecting: false
    }
  },

  methods: {
    ...mapGetters({
      getLastWatched: 'getLastWatched',
    }),

    ...mapActions({
      setHeaderVisibility: 'setHeaderVisibility',
      getNewsAvailable: 'getNewsAvailable'
    }),

    ...mapMutations({
      setTopScroll: 'setTopScroll',
    }),
  },

  mounted() {
    this.setHeaderVisibility(true)

    this.getNewsAvailable()

    axios.get('/api/lastWatched')
        .then((result) => {
          this.renderData.products = result.data
        })
        .finally(() => this.isLoading = false)

    //axios.get('api/crud/products')
  },

  computed: {
    ...mapGetters({
      getUserId: 'getUserId'
    }),
  },

  watch: {
    isLoading: {
      handler(state) {
        if(!state) {
          this.$nextTick(function () {
            let articlesHeight = this.$refs["lastArticlesHeader"].clientHeight
            let windowHeight = window.innerHeight
            this.intersectThreshold = (windowHeight - 100) / articlesHeight
            this.intersectValue = (windowHeight -100) / articlesHeight

            if(this.intersectThreshold >= 0 && this.intersectThreshold <= 1) {
              let target = this.$refs["lastArticlesHeader"]

              let options = {
                threshold: this.intersectThreshold
              }

              let callback = (entries) => {
                if(entries[0].intersectionRatio >= this.intersectValue) {
                  this.isIntersecting = true
                  this.setTopScroll(true)
                }
                if(entries[0].intersectionRatio < this.intersectValue) {
                  this.isIntersecting = false
                  this.setTopScroll(false)
                }
              }

              let observer = new IntersectionObserver(callback, options)
              observer.observe(target)
            }
          })
        }
      }
    }
  },
}
</script>
<style>
  .skeletonAvatar .v-skeleton-loader__avatar.v-skeleton-loader__bone{
    height:40px;
    width: 40px;
    border-radius: 0px!important;
    margin-right: 20px;
  }

  .skeletonAvatar {
    top: -25px;
    position: relative;
  }

  .skeletonWrapper__li {
    display: flex;
  }

  .scrollTopBtn.v-btn {
    bottom: 100px;
    background-color: var(--igros-red)!important;
  }

  .scrollTopBtn svg {
    color: white!important;
  }
</style>
